// services
import styled from 'styled-components';
import { Link } from 'react-router-dom';

export function DashboardRoute(): JSX.Element {

	return (
		<Container className="dashboard-container">

			<div className='cards-container'>

				<Link to={'/dashboards/statistics'}>
					<div className='card'>
						<p>Statistik</p>
						<img src='https://filer.boblberg.dk/assets/img/admin/chart-simple-light.svg' />
					</div>
				</Link>
				<Link to={'/dashboards/statistics-denmark'}>
					<div className='card'>
						<p>Statistik DK</p>
						<img src='https://filer.boblberg.dk/assets/img/admin/chart-simple-light.svg' />
					</div>
				</Link>
				<Link to={'/dashboards/statistics-sweden'}>
					<div className='card'>
						<p>Statistik SE</p>
						<img src='https://filer.boblberg.dk/assets/img/admin/chart-simple-light.svg' />
					</div>
				</Link>
				<Link to={'/dashboards/statistics-germany'}>
					<div className='card'>
						<p>Statistik DE</p>
						<img src='https://filer.boblberg.dk/assets/img/admin/chart-simple-light.svg' />
					</div>
				</Link>
				<Link to={'/dashboards/subscriptions'}>
					<div className='card'>
						<p>Abonnenter</p>
						<img src='https://filer.boblberg.dk/assets/img/admin/credit-card-light.svg' />
					</div>
				</Link>
				<Link to={'/dashboards/subscriptions-revenue'}>
					<div className='card'>
						<p>Omsætning</p>
						<img src='https://filer.boblberg.dk/assets/img/admin/money-check-dollar-light.svg' />
					</div>
				</Link>
				<Link to={'/dashboards/events'}>
					<div className='card'>
						<p>Events</p>
						<img src='https://filer.boblberg.dk/assets/img/admin/calendar-star-light.svg' />
					</div>
				</Link>
				<Link to={'/dashboards/activities'}>
					<div className='card'>
						<p>Aktivitet</p>
						<img src='https://filer.boblberg.dk/assets/img/admin/wave-pulse-light.svg' />
					</div>
				</Link>
				<Link to={'/dashboards/oplevalt'}>
					<div className='card'>
						<p>OplevAlt</p>
						<img src='https://filer.boblberg.dk/assets/img/admin/money-check-dollar-light.svg' />
					</div>
				</Link>
				<Link to={'/dashboards/julevenner'}>
					<div className='card'>
						<p>Julevenner</p>
						<img src='https://filer.boblberg.dk/assets/img/admin/tree-christmas-light.svg' />
					</div>
				</Link>
				<Link to={'/dashboards/new-year'}>
					<div className='card'>
						<p>Nytårsvenner</p>
						<img src='https://filer.boblberg.dk/assets/img/admin/champagne-glasses-light.svg' />
					</div>
				</Link>
				<Link to={'/dashboards/user-stories'}>
					<div className='card'>
						<p>Historier</p>
						<img src='https://filer.boblberg.dk/assets/img/admin/user-light.svg' />
					</div>
				</Link>

			</div>

		</Container>
	);
}

const Container = styled.main`
	background-color: #1a202c;
	display: flex;
	align-items: center;
	justify-content: center;

	.cards-container {
		display: flex;
		flex-wrap: wrap;
		gap: 24px;
		max-width: 800px;
		margin: 24px;
	}
	
	.card {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 250px;
		height: 150px;
		background-color: #1f2937;
		box-shadow: rgba(0,0,0,0.2) 0px 2px 8px 0px;
		padding: 2em;
		border-radius: 0.5em;

		opacity: 100%;
		transition: opacity 200ms;
	}

	.card:hover {
		opacity: 50%;
		transition: opacity 200ms;
	}

	p {
		color: rgba(255,255,255,0.9);
		font-weight: bold;
		margin: 0;
	}

	img {
		max-width: 30px;
		max-height: 26px;
		opacity: 90%;
	}

	@media (max-width: 575px) {
		align-items: flex-start;

		.cards-container {
			justify-content: center;
		}

		.card {
			height: 125px;
		}
	}
`;
